import React from "react";
import PropTypes from "prop-types";
import FileItemRow from "./FileItemRow";

const FilesSection = ({
  resources,
  productionSettings,
  handleCheckboxChange,
  selectedResources,
  folder,
  handleFileNotifyChange,
  propertyFormValues,
  onChangeQuantity,
  folderPropertyFormValues,
  handleRemoveFileSettings,
  showCheckbox,
}) => {
  const { quantityProperty = {}, productionProperties = [] } =
    productionSettings || {};

  const folderFormValues = folderPropertyFormValues.find(
    x => x.folderId === folder.folderId
  );

  return (
    <>
      {resources.map(x => {
        const isSelected = selectedResources.some(y => y === x.id);

        const itemFormValue = propertyFormValues.find(
          z => z.resourceId === x.id
        );

        let { isNotifyEnabled } = itemFormValue || {};

        if (isNotifyEnabled === null || isNotifyEnabled === undefined) {
          const { isNotifyEnabled: folderIsNotifyEnabled = false } =
            folderFormValues || {};
          isNotifyEnabled = folderIsNotifyEnabled;
        }
        const { productionSettings: productionSettingsValues = {} } =
          itemFormValue || {};

        const { orderQuantity, quantityFixedValueId } =
          productionSettingsValues || {};

        let quantity;

        if (
          (quantityFixedValueId !== null &&
            quantityFixedValueId !== undefined) ||
          (orderQuantity !== null && orderQuantity !== undefined)
        ) {
          if (quantityProperty.quantityType === "FIXED") {
            quantity = quantityFixedValueId;
          } else {
            quantity = orderQuantity;
          }
        } else {
          const { productionSettings: folderSettingsValues = {} } =
            folderFormValues || {};

          const {
            orderQuantity: folderOrderQuantity,
            quantityFixedValueId: folderQuantityFixedValueId,
          } = folderSettingsValues || {};

          quantity =
            quantityProperty.quantityType === "FIXED"
              ? folderQuantityFixedValueId
              : folderOrderQuantity;
        }

        return (
          <FileItemRow
            key={x.id}
            showCheckbox={showCheckbox}
            handleCheckboxChange={handleCheckboxChange}
            isSelected={isSelected}
            quantityProperty={quantityProperty}
            resource={x}
            folder={folder}
            productionProperties={productionProperties}
            handleFileNotifyChange={handleFileNotifyChange}
            isNotifyEnabled={isNotifyEnabled}
            onChangeQuantity={onChangeQuantity}
            quantity={quantity}
            folderFormValues={folderFormValues}
            itemFormValue={itemFormValue}
            handleRemoveFileSettings={handleRemoveFileSettings}
          />
        );
      })}
    </>
  );
};

FilesSection.defaultProps = {
  resources: [],
  folderPropertyFormValues: [],
};

FilesSection.propTypes = {
  resources: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired })
  ),
  handleCheckboxChange: PropTypes.func.isRequired,
  handleFileNotifyChange: PropTypes.func.isRequired,
  handleRemoveFileSettings: PropTypes.func.isRequired,
  onChangeQuantity: PropTypes.func.isRequired,
  selectedResources: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ).isRequired,
  productionSettings: PropTypes.shape({
    quantityProperty: PropTypes.shape({}),
  }).isRequired,
  folder: PropTypes.shape({ folderId: PropTypes.number }).isRequired,
  folderPropertyFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  propertyFormValues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default FilesSection;
